import axios from 'axios'
import {router} from '../routes'
import { v4 as uuidv4 } from 'uuid';
import Vue from "vue";
import {getPrixLivraison} from "../app";

function calculerTotal(produit) {
    let total = produit.price;
    // 1. SUPPLEMENTS
    [
        // On récupère tout supplément payant
        produit.choix_client.more_supplements,
        produit.choix_client.more_boissons,
        produit.choix_client.more_sauces,
        produit.choix_client.taxonomieitems,
    ].forEach(items => {
        items.forEach(item => total += item.price)
    })

    // 2. TAXONOMIES
    // Etant donné que le tableau est composé soit d'array d'objects si ça provient d'une checkbox (car on peut en avoir plusieurs)
    // soit d'un object si ça provient d'une radio (car on ne peut en avoir qu'un, du coup Vue le place à la racine et non pas dans un tableau)
    // Pour vérifier on vérifie simplement si on a accès à "item.id" s'il renvoie un id, c'est une radio, si undefined c'est que c'est une checkbox
    /*Object.entries(produit.choix_client.taxonomieitems).forEach(([key, ObjetOuArray]) => {
        if(ObjetOuArray.id) { total += ObjetOuArray.price; } // Radio (un seul choix)
        else { ObjetOuArray.forEach(item => total += item.price) } // Checkboxes (multiple choix)
    });*/

    produit.choix_client.total = total * produit.choix_client.quantite;
    return produit;
}


export default {
    namespaced: true,
    state:{
        items: [], // elements du panier
        openedProduit: false,
        supplement_livraison: 95, // total de la livraison
        total: 0, // sous_total
        total_a_payer: 0, // total à payer
        adresseCommande: false, // adresse spécifique pour la commande en cours
        mode_retrait: 'livraison',
        mode_reglement: 'especes',
    },
    getters: {
        getCount: (state) => {
            return state.items.length;
        }
    },
    mutations: {
        clearPanier(state) {
            state.items = [];
            state.total = 0;
        },
        addItem(state, item) {
            state.items.push(item)
        },
        removeItem(state, id_item) {
            const index = state.items.findIndex(item => item.id_item === id_item);
            state.items.splice(index, 1);
        },
        setOpenedProduit (state, produit) {
            state.openedProduit = produit
        },
		setSupplementLivraison(state, supplement_livraison) {
			state.supplement_livraison = supplement_livraison
		},
        updateProduitTotal(state, id_item) {
            const index = state.items.findIndex(item => item.id_item === id_item);
            state.items[index] = calculerTotal(state.items[index]);
        },
        updateOpenedProduitTotal(state, produit) {
            state.openedProduit = calculerTotal(produit);
        },
        updateTotal(state) {
            let total = 0;
            state.items.forEach(item => {
                total += item.choix_client.total;
            });
            state.total = total;
            state.total_a_payer = state.mode_retrait === 'livraison' ? total + state.supplement_livraison : total;
        },
        // Si le client veut une adresse spécifique pour la commande en acours
        updateAdresseCommande(state, adresse) {
            state.adresseCommande = adresse;
        },
        resetAdresseCommande(state) {
            state.adresseCommande = false;
        },
        setModeRetrait (state, mode_retrait) { state.mode_retrait = mode_retrait; },
        setModeReglement (state, mode_reglement) { state.mode_reglement = mode_reglement },
    },
    actions: {
        addItem(context, item) {
            item.id_item = uuidv4();
            context.commit('addItem', item);
            context.commit('updateTotal');
        },
        removeItem(context, id_item) {
            context.commit('removeItem', id_item);
            context.commit('updateTotal');
        },
        updateProduitTotal(context, id_item) {
            context.commit('updateProduitTotal', id_item)
            context.commit('updateTotal')
        },
        updateOpenedProduitTotal(context, produit) {
            context.commit('updateOpenedProduitTotal', produit)
            context.commit('updateTotal')
        },
		updateSupplementLivraison(context, code_postal = null) {
			const prixDefault = getPrixLivraison.default;
			let prixLivraison = prixDefault;
			if(code_postal && !context.state.adresseCommande) {
				prixLivraison = getPrixLivraison[code_postal] || prixDefault
			} else {
				prixLivraison = getPrixLivraison[context.state.adresseCommande.code_postal] || prixDefault
			}
			context.commit('setSupplementLivraison', prixLivraison);
			context.commit('updateTotal')
		},
        async setOpenedProduit(context, id_item) {
            const produit = context.state.items.find(item => item.id_item === id_item)
            context.commit('setOpenedProduit', produit);
        },
    },
};
